/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserIdAddress
 */
export interface UserIdAddress {
    /**
     * 
     * @type {string}
     * @memberof UserIdAddress
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UserIdAddress
     */
    address: string;
}

/**
 * Check if a given object implements the UserIdAddress interface.
 */
export function instanceOfUserIdAddress(value: object): value is UserIdAddress {
    let isInstance = true;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;
    isInstance = isInstance && "address" in value && value["address"] !== undefined;

    return isInstance;
}

export function UserIdAddressFromJSON(json: any): UserIdAddress {
    return UserIdAddressFromJSONTyped(json, false);
}

export function UserIdAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserIdAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'address': json['address'],
    };
}

export function UserIdAddressToJSON(value?: UserIdAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
        'address': value.address,
    };
}

